"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimilarToKitData = void 0;
const enums_1 = require("../../sales-order/enums");
const responses_1 = require("../../sales-order/responses");
class SimilarToKitData {
}
exports.SimilarToKitData = SimilarToKitData;
//# sourceMappingURL=similar-to-kit-data.response.js.map